import type { RouteRecordRaw } from 'vue-router';
const routes: RouteRecordRaw[] = [
  {
    path: '/x5Config',
    name: 'x5Config',
    children: [
      {
        path: 'mentoSystem/:serverId',
        name: 'x5MentoSystem',
        component: () => import('@/views/wiki/x5config/mentoSystem/index.vue'),
        meta: {
          title: '师徒系统',
          layout: 'share'
        }
      },
      {
        path: 'apprenticeDetail/:serverId/:discipleId',
        name: 'x5ApprenticeDetail',
        component: () => import('@/views/wiki/x5config/mentoSystem/apprenticeDetail.vue'),
        meta: {
          title: '徒弟详情',
          layout: 'share'
        }
      },
      {
        path: 'mentoRank/:serverId',
        name: 'x5MentoRank',
        component: () => import('@/views/wiki/x5config/mentoRank/index.vue'),
        meta: {
          title: '名师榜',
          layout: 'share'
        }
      },
      {
        path: 'mentoRankReward/:serverId',
        name: 'x5MentoRankReward',
        component: () => import('@/views/wiki/x5config/mentoRank/rewardPage.vue'),
        meta: {
          title: '名师任务',
          layout: 'share'
        }
      },
      {
        path: 'homePage/:id?',
        name: 'X5HomePage',
        component: () => import('@/views/wiki/x5config/homePage/index.vue'),
        meta: {
          title: '个人主页',
          userSource: 'X5_roleInfoShare',
          layout: 'share'
        }
      },
      {
        path: 'weekReport',
        name: 'x5WeekReport',
        component: () => import('@/views/games/x5/weekReport/index.vue'),
        meta: {
          title: '周报',
          layout: 'share'
        }
      }
    ]
  }
];

export default routes;
